import _ from 'lodash'

export function buildInteractionId(prefix, interactionSequence) {
  return `${prefix}-${interactionSequence + 1}`
}

export function startDeferredInteraction({
  value = [],
  interactionSequence = 0,
  prefix,
}) {
  return {
    interactionSequence: interactionSequence + 1,
    menuCurrentValue: globalThis.structuredClone(value),
    menuInitialValue: globalThis.structuredClone(value),
    menuInteractionId: buildInteractionId(prefix, interactionSequence),
  }
}

export function finishDeferredInteraction({
  fallbackValue = [],
  menuCurrentValue = null,
  menuInitialValue = null,
}) {
  const finalValue = globalThis.structuredClone(
    menuCurrentValue ?? fallbackValue
  )
  const initialValue = globalThis.structuredClone(menuInitialValue ?? [])

  return {
    didChange: !_.isEqual(initialValue, finalValue),
    finalValue,
  }
}
